export default "__VITE_ASSET__DBwbnZvy__"